import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW1201Model } from "../kymw1201.model";
import { PublishPlanGoodsCategory } from "../vo/publish-plan-goods-category-list-info.model";

/**
 * サイクル企画商品クロス設定情報を削除するサービス
 * 
 * @export DeleteCyclePlanGoodsCrossService
 * @class DeleteCyclePlanGoodsCrossService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class DeleteCyclePlanGoodsCrossService extends PlessJsonResponderSub<any> {

  private model: KYMW1201Model;
  private vo: PublishPlanGoodsCategory;
  private succeed: () => void;
  private fail: () => void;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteCyclePlanGoodsCrossService
   */
  getBody() {
    return new PlessRequest({
      delete: {
        deleteCrossSet: {
          condition: {
            OrderCode: this.vo.orderCode,
            CrossCode: this.vo.crossCode,
            MediumType: this.model.mediumType,
          }
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param vo 
   * @param s 
   * @memberof DeleteCyclePlanGoodsCrossService
   */
  execute(model: KYMW1201Model, vo: PublishPlanGoodsCategory, s: () => void = null, f: () => void = null) {
    this.model = model;
    this.vo = vo;
    this.succeed = s;
    this.fail = f;
    this.send('deleteCyclePlanGoodsCross', this.getBody());
  }

  /**
   * API通信成功時の処理
   * 
   * @memberof DeleteCyclePlanGoodsCrossService
   */
  success(): void {
    if (this.succeed) this.succeed();
  }

  /**
   * StatusがOK以外の場合の処理
   * 独自のステータス処理を実装したい場合はこのメソッドをオーバーライドする
   *
   * @param status statauタグの値
   * @param result レスポンスの内容(rspタグの値)
   */
  statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}